module.exports = __webpack_public_path__ + "static/media/filters.b0404d05.svg";